var map = {
	".": 8305,
	"./": 8305,
	"./App": 4843,
	"./App.js": 4843,
	"./Company": 8829,
	"./Company.js": 8829,
	"./Cover": 162,
	"./Cover.js": 162,
	"./Footer": 9570,
	"./Footer.js": 9570,
	"./Home": 3769,
	"./Home.js": 3769,
	"./LanguageSelector": 5618,
	"./LanguageSelector.js": 5618,
	"./Navbar": 9208,
	"./Navbar.js": 9208,
	"./ProgressBar": 4649,
	"./ProgressBar.js": 4649,
	"./ScrollUpButton": 6472,
	"./ScrollUpButton.js": 6472,
	"./Services": 9786,
	"./Services.js": 9786,
	"./ServicesModal": 8197,
	"./ServicesModal.js": 8197,
	"./Team": 3132,
	"./Team.js": 3132,
	"./index": 8305,
	"./index.js": 8305,
	"./jsons/en/company_en": 3670,
	"./jsons/en/company_en.json": 3670,
	"./jsons/en/cover_en": 4023,
	"./jsons/en/cover_en.json": 4023,
	"./jsons/en/footer_en": 7036,
	"./jsons/en/footer_en.json": 7036,
	"./jsons/en/navbar_en": 9224,
	"./jsons/en/navbar_en.json": 9224,
	"./jsons/en/services_en": 6508,
	"./jsons/en/services_en.json": 6508,
	"./jsons/en/services_modal_en": 4487,
	"./jsons/en/services_modal_en.json": 4487,
	"./jsons/en/team_en": 3189,
	"./jsons/en/team_en.json": 3189,
	"./jsons/pt/company_pt": 6844,
	"./jsons/pt/company_pt.json": 6844,
	"./jsons/pt/cover_pt": 5583,
	"./jsons/pt/cover_pt.json": 5583,
	"./jsons/pt/footer_pt": 2566,
	"./jsons/pt/footer_pt.json": 2566,
	"./jsons/pt/navbar_pt": 7020,
	"./jsons/pt/navbar_pt.json": 7020,
	"./jsons/pt/services_modal_pt": 7845,
	"./jsons/pt/services_modal_pt.json": 7845,
	"./jsons/pt/services_pt": 8608,
	"./jsons/pt/services_pt.json": 8608,
	"./jsons/pt/team_pt": 5178,
	"./jsons/pt/team_pt.json": 5178,
	"./resources/icons/arrow.png": 6921,
	"./resources/icons/arrow.svg": 1325,
	"./resources/icons/error.png": 5569,
	"./resources/icons/facebook_icon_filled.png": 861,
	"./resources/icons/hamburger.png": 2607,
	"./resources/icons/light_bulb.png": 6598,
	"./resources/icons/linkedin_icon_filled.png": 7718,
	"./resources/icons/linkedin_icon_filled_white.png": 589,
	"./resources/icons/medium.png": 1138,
	"./resources/icons/menu.png": 1976,
	"./resources/icons/menu_2.png": 9602,
	"./resources/icons/menu_2_white.png": 298,
	"./resources/icons/menu_white.png": 3277,
	"./resources/icons/success.png": 7029,
	"./resources/icons/up-arrow.png": 153,
	"./resources/icons/up_arrow.png": 4441,
	"./resources/icons/up_arrow_blue.png": 243,
	"./resources/icons/up_arrow_dark_blue.png": 9371,
	"./resources/images/background_image_4.jpg": 6957,
	"./resources/images/background_image_7.jpg": 1133,
	"./resources/images/blackDots.svg": 7945,
	"./resources/images/circles.png": 9033,
	"./resources/images/company_background_image.jpg": 87,
	"./resources/images/company_background_image_blue.png": 8583,
	"./resources/images/dots.svg": 93,
	"./resources/images/gggyrate.svg": 2911,
	"./resources/images/health_tech_portugal_logo.png": 1484,
	"./resources/images/lets_talk_banner.png": 5312,
	"./resources/images/logo_expanded.png": 3999,
	"./resources/images/logo_expanded_white.png": 9554,
	"./resources/images/logo_simplified.png": 2217,
	"./resources/images/luis_fatela.png": 4630,
	"./resources/images/luis_fatela_2.png": 2075,
	"./resources/images/luis_fatela_2_og.jpg": 7547,
	"./resources/images/market_access_services.jpg": 5116,
	"./resources/images/mmmotif-3.svg": 5972,
	"./resources/images/patricia_lindeza.jpg": 7289,
	"./resources/images/patricia_lindeza_og.jpg": 633,
	"./resources/images/qqquad.svg": 2902,
	"./resources/images/regulatory_services.jpg": 5141,
	"./resources/images/rita_salvado_melo.jpeg": 1878,
	"./resources/images/robert_le_blanc.png": 5041,
	"./resources/images/rrreflection-2.svg": 4407,
	"./resources/images/validation_services.png": 7925,
	"./resources/images/vitor.jpeg": 8070,
	"./resources/videos/diagram_en.m4v": 9680,
	"./resources/videos/diagram_pt.m4v": 1465,
	"./styles/Inter/Inter-Black.otf": 3012,
	"./styles/Inter/Inter-BlackItalic.otf": 7365,
	"./styles/Inter/Inter-Bold.otf": 8549,
	"./styles/Inter/Inter-BoldItalic.otf": 1903,
	"./styles/Inter/Inter-ExtraBold.otf": 5691,
	"./styles/Inter/Inter-ExtraBoldItalic.otf": 6637,
	"./styles/Inter/Inter-ExtraLight.otf": 9420,
	"./styles/Inter/Inter-ExtraLightItalic.otf": 7805,
	"./styles/Inter/Inter-Italic.otf": 2210,
	"./styles/Inter/Inter-Light.otf": 3304,
	"./styles/Inter/Inter-LightItalic.otf": 2388,
	"./styles/Inter/Inter-Medium.otf": 5197,
	"./styles/Inter/Inter-MediumItalic.otf": 3898,
	"./styles/Inter/Inter-Regular.otf": 3231,
	"./styles/Inter/Inter-SemiBold.otf": 2939,
	"./styles/Inter/Inter-SemiBoldItalic.otf": 6948,
	"./styles/Inter/Inter-Thin.otf": 485,
	"./styles/Inter/Inter-ThinItalic.otf": 6115,
	"./styles/Inter/Inter-V.ttf": 5425,
	"./styles/app.module.scss": 4449,
	"./styles/company.module.scss": 2231,
	"./styles/cover.module.scss": 6659,
	"./styles/footer.module.scss": 3692,
	"./styles/home.module.scss": 9555,
	"./styles/language_selector.module.scss": 8500,
	"./styles/navbar.module.scss": 8483,
	"./styles/scroll_up_button.module.scss": 6566,
	"./styles/services.module.scss": 3162,
	"./styles/services_modal.module.scss": 7010,
	"./styles/team.module.scss": 3319
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;